import { render } from "./MileageCases.vue?vue&type=template&id=dad6fdc2"
import script from "./MileageCases.vue?vue&type=script&lang=js"
export * from "./MileageCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/MileageCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dad6fdc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dad6fdc2', __exports__)) {
    console.log('reload')
    api.reload('dad6fdc2', __exports__)
  }
  
  module.hot.accept("./MileageCases.vue?vue&type=template&id=dad6fdc2", () => {
    console.log('re-render')
    api.rerender('dad6fdc2', render)
  })

}


export default __exports__